import { useEffect, useState } from "react";

export default function VideoCanvas({ background_url, onVideoEnd, video_ref }){

	const [hasPlayed, setHasPlayed]=useState(false);

	useEffect(()=>{

		if (video_ref?.current && background_url){

			//Build up video component
			const video = document.createElement("video");
			video.src = background_url;
			video.controls = true;
			video.playsInline = true;
			const canvas = video_ref.current;
			const context = canvas.getContext("2d");
			const aspectRatio = 1920 / 1080;
			let videoWidth, videoHeight;

			//Get dimensions
			function calculateDimensions(){
				const windowWidth = window.innerWidth;
				const windowHeight = window.innerHeight;
				const windowAspectRatio = windowWidth / windowHeight;
				if(windowAspectRatio < aspectRatio){
					videoWidth = windowWidth;
					videoHeight = windowWidth / aspectRatio;
					canvas.width = windowWidth;
					canvas.height = windowWidth / aspectRatio;
				} 
				else{
					videoWidth = windowHeight * aspectRatio;
					videoHeight = windowHeight;
					canvas.width = windowHeight * aspectRatio;
					canvas.height = windowHeight;
				}
			}

			calculateDimensions();

			let animationFrameId;

			//Draw to canvas
			function draw(){
				try{
					context.drawImage(video, 0, 0, videoWidth, videoHeight);
				}
				catch(error){
					console.error(error)
				}
				animationFrameId = requestAnimationFrame(draw);
			}

			//Event functions
			function onMetadataLoaded(){
				video.play();
				draw();
			}
			function onEnded(){
				if(onVideoEnd){
					onVideoEnd();
				}
			}
			function onResize(){
				calculateDimensions();
			}

			//Event listeners
			video.addEventListener('loadedmetadata', onMetadataLoaded);
			video.addEventListener('ended', onEnded);
			window.addEventListener('resize', onResize);

			// Only set hasPlayed once
			if(!hasPlayed){
				setHasPlayed(true);
			}

			//Clean up event listeners and renders to prevent memory leaks
			return()=>{
				video.removeEventListener('loadedmetadata', onMetadataLoaded);
				video.removeEventListener('ended', onEnded);
				window.removeEventListener('resize', onResize);
				cancelAnimationFrame(animationFrameId);
				video.pause();
			}

		}

	}, [video_ref, background_url, onVideoEnd, hasPlayed]);

	return(
		<canvas ref={video_ref} id="video-canvas"></canvas>
	);
	
};